import {createStore} from 'vuex';
import propertiesModule from './index_properties.js';
import authModule from './authstore.js'; // 1. Import the auth module


const store=createStore({
    modules:{
        properties: propertiesModule,
        auth: authModule // 2. Register the auth module
    },
    state(){
        return {

        }
    },
    getters:{},
});

export default store;
